import React, { createContext, useContext, ReactNode } from 'react';
import FirebaseService from '../services/firebaseService';

// Create context for the FirebaseService
interface FirebaseServiceContextType {
  firebaseService: FirebaseService;
}

const FirebaseServiceContext = createContext<FirebaseServiceContextType | undefined>(undefined);

// Provider component
interface FirebaseServiceProviderProps {
  children: ReactNode;
}

export const FirebaseServiceProvider: React.FC<FirebaseServiceProviderProps> = ({ children }) => {
  const firebaseService = FirebaseService.getInstance();
  
  return (
    <FirebaseServiceContext.Provider value={{ firebaseService }}>
      {children}
    </FirebaseServiceContext.Provider>
  );
};

// Custom hook to use the FirebaseService
export const useFirebaseService = (): FirebaseServiceContextType => {
  const context = useContext(FirebaseServiceContext);
  
  if (context === undefined) {
    throw new Error('useFirebaseService must be used within a FirebaseServiceProvider');
  }
  
  return context;
}; 